import {z} from "zod"
import {frequencySchema} from "@indebted/payment-arrangement/Slider/Frequency"

import {getJson} from "../http"

const PaymentArrangementEFTASchema = z.strictObject({
	InstalmentAmount: z.number(),
	Currency: z.string(),
	PaymentMethodLast4Digits: z.string(),
	RoutingNumber: z.string(),
	Frequency: frequencySchema,
	StartDate: z.coerce.date(),
	EndDate: z.coerce.date(),
	ClientName: z.string(),
	EntityName: z.string(),
	PaymentMethod: z.string(),
	PaymentFormPage: z.string(),
	PublishableKey: z.string(),
	type: z.literal("value"),
})

const NextResponseSchema = z.object({
	Next: z.string(),
	type: z.literal("redirect"),
})

const PaymentArrangementEFTAResponseSchema = z.preprocess(
	(data: any) => {
		if (data.Next) {
			return {Next: data.Next, type: "redirect"}
		}
		return {type: "value", ...data}
	},
	z.discriminatedUnion("type", [PaymentArrangementEFTASchema, NextResponseSchema]),
)

type PaymentArrangementEFTA = z.infer<typeof PaymentArrangementEFTAResponseSchema>

export async function getEFTAPage(
	paymentArrangementID: string,
	confirmationTokenID: string,
): Promise<PaymentArrangementEFTA> {
	const searchParams = new URLSearchParams({
		ConfirmationTokenID: confirmationTokenID,
	})

	return await getJson(
		`/app/payment-arrangements/${paymentArrangementID}/efta?${searchParams.toString()}`,
		PaymentArrangementEFTAResponseSchema,
	)
}
